module.exports = __webpack_public_path__ + "static/img/组 2950.b6c2b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/images/组 2950.png
// module id = w9w5
// module chunks = 0